// tslint:disable:max-classes-per-file
var Carrier = /** @class */ (function () {
    function Carrier() {
        this.id = '';
        this.name = '';
        this.groupId = '';
        this.isHorizonEnabled = false;
        this.apiPassword = '';
        this.notes = '';
        this.desks = [];
        this.status = '';
        this.isDeleted = false;
    }
    return Carrier;
}());
export { Carrier };
var DispatchDesk = /** @class */ (function () {
    function DispatchDesk() {
        this.id = '';
        this.name = '';
        this.parentId = '';
        this.email = '';
        this.snapshotTime = '';
        this.status = '';
        this.isDefault = false;
    }
    return DispatchDesk;
}());
export { DispatchDesk };
var UnflattenedCarrier = /** @class */ (function () {
    function UnflattenedCarrier() {
        this.groups = [];
        this.carriers = [];
        this.desks = [];
    }
    return UnflattenedCarrier;
}());
export { UnflattenedCarrier };
var SaveCarrierResponse = /** @class */ (function () {
    function SaveCarrierResponse() {
        this.carrierId = '';
    }
    return SaveCarrierResponse;
}());
export { SaveCarrierResponse };
var SaveDispatchDeskResponse = /** @class */ (function () {
    function SaveDispatchDeskResponse() {
        this.carrierDispatchDeskId = '';
    }
    return SaveDispatchDeskResponse;
}());
export { SaveDispatchDeskResponse };
